// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2577":"cddc1605","5425":"cddc1605"}[chunkId] + ".chunk.css";
};